import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=c92a2046&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=c92a2046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92a2046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c92a2046')) {
      api.createRecord('c92a2046', component.options)
    } else {
      api.reload('c92a2046', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=c92a2046&scoped=true&", function () {
      api.rerender('c92a2046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zCDZhw8C4LOg/JS/comp/DocBox.vue"
export default component.exports